import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { BaseProvider } from '@!/providers'
import { CoinPurchase } from '@!/ExternalPayment/CoinPurchase/containers/CoinPurchase'
import { SelectPaymentMethod } from '@!/ExternalPayment/CoinPurchase/containers/SelectPaymentMethod'
import { NewCard } from '@!/ExternalPayment/CoinPurchase/containers/NewCard'
import { PurchaseConfirm } from '@!/ExternalPayment/CoinPurchase/containers/PurchaseConfirm'
import { PurchaseComplete } from '@!/ExternalPayment/CoinPurchase/containers/PurchaseComplete'
import { useExternalPaymentSettings } from '../hooks/useExternalPaymentSettings'

export default function CoinPurchaseApp({ current_coin_count, coin_plans, credit_token_api_key, credit_token_public_key }) {
  const jotaiStore = useExternalPaymentSettings({
    creditTokenApiKey: credit_token_api_key,
    creditTokenPublicKey: credit_token_public_key,
  })

  return (
    <BaseProvider jotaiStore={jotaiStore}>
      <Routes>
        <Route path="/" element={<CoinPurchase currentCoinCount={current_coin_count} coinPlans={coin_plans} />} />
        <Route path="/select_payment_method" element={<SelectPaymentMethod coinPlans={coin_plans} />} />
        <Route path="/new_card" element={<NewCard coinPlans={coin_plans} />} />
        <Route path="/confirm" element={<PurchaseConfirm coinPlans={coin_plans} />} />
        <Route path="/complete" element={<PurchaseComplete />} />
      </Routes>
    </BaseProvider>
  )
}
